module.exports = __webpack_public_path__ + "static/gt-logo-gold-13ce4d51b8728df1d8f626f288c813fe.png";